// 通用名称校验
export const displayNameRules = {
    maxLength: 20,
    message: "开头和结尾不允许有空格",
}

// 用户名校验
export const userNameRules = {
    minLength: 2,
    maxLength: 20,
    pattern: /^[A-Za-z0-9_\u4e00-\u9fa5]{2,20}$/,
    message: "2-20位字符,仅可含汉字,字母,数字,下划线",
}

// 名称校验
export const nameRules = {
    minLength: 2,
    pattern: /^[a-zA-Z\u4e00-\u9fa5][a-zA-Z0-9\u4e00-\u9fa5]{1,}$/,
    message: "中英文开头，支持汉字、字母,不少于两个字符",
}

// 手机号码校验
export const phoneRules = {
    maxLength: 11,
    pattern: /^[1][2-9][0-9]{9}$/,
    message: "请输入合法的手机号码",
}

// 邮箱地址校验
export const emailRules = {
    maxLength: 256,
    pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
    message: "请输入合法的邮箱地址",
}

// 公司名称校验
export const companyRules = {
    maxLength: 20,
    pattern: /^[a-zA-Z\u4e00-\u9fa5][\w\u4e00-\u9fa5-()[\]]{2,19}$/,
    message: '3~20位字符, 中英文开头，支持汉字、字母、数字和-_()[]'
}

// 企业类型校验
export const enterpriseTypeRules = {
    maxLength: 20,
    pattern: /^[a-zA-Z\u4e00-\u9fa5][\w\u4e00-\u9fa5\d\-_()[\]]{1,}$|其他/,
    message: '中英文开头, 支持汉字、字母、数字和-_()[], 不少于两个字符'
}

// 企业类型输入校验
export const enterpriseTypeInputRules = {
    maxLength: 20,
    pattern: /^[a-zA-Z\u4e00-\u9fa5][\w\u4e00-\u9fa5\d\-_()[\]]{1,}$/,
    message: '中英文开头, 支持汉字、字母、数字和-_()[], 不少于两个字符'
}

// 职位名称校验
export const positionRules = {
    pattern: /^[a-zA-Z\u4e00-\u9fa5][\w\u4e00-\u9fa5\d]{1,}$|其他/,
    message: '中英文开头, 支持汉字、字母、数字, 不少于两个字符'
}

// 职位名称输入校验
export const positionInputRules = {
    pattern: /^[a-zA-Z\u4e00-\u9fa5][\w\u4e00-\u9fa5\d]{1,}$/,
    message: '中英文开头, 支持汉字、字母、数字, 不少于两个字符'
}

// 密码校验
export const passwordRules = {
    minLength: 8,
    maxLength: 24,
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$.@$!%*?&#])[A-Za-z\d$.@$!%*?&#]{8,24}$/,
    message: '8-24位字符，至少包含大,小写字母,数字,特殊字符(.@$!%*?&#)各一位'
}